import { axiosRequest } from '@/util/axios-request';

// 解散公司
export var dismissCompany = function dismissCompany(data) {
  return axiosRequest({
    url: '/web/company/dismiss',
    data: data
  });
};

// 更换主管理员
export var transfer = function transfer(data) {
  return axiosRequest({
    url: '/web/company/transfer',
    data: data
  });
};

// 获取公司信息
export var getCompanyInfo = function getCompanyInfo(data) {
  return axiosRequest({
    url: '/web/company/info',
    data: data
  });
};

// 获取企业邀请码
export var getCode = function getCode(data) {
  return axiosRequest({
    url: '/web/invite/getcode',
    data: data
  });
};
// 更新企业邀请码
export var getCreateCode = function getCreateCode(data) {
  return axiosRequest({
    url: '/web/invite/createcode',
    data: data
  });
};

// 申请人列表
export var getPendingList = function getPendingList(data) {
  return axiosRequest({
    url: '/web/invite/pendingList',
    data: data
  });
};
// 激活码开关
export var switchstate = function switchstate(data) {
  return axiosRequest({
    url: '/web/invite/switchstate',
    data: data
  });
};

// 权限资源列表
export var recouseList = function recouseList(data) {
  return axiosRequest({
    url: '/web/resource/list',
    data: data
  });
};

// 创建权限组
export var createGroup = function createGroup(data) {
  return axiosRequest({
    url: '/web/privilege_group/create',
    data: data
  });
};

// 权限组更新
export var modifyGroup = function modifyGroup(data) {
  return axiosRequest({
    url: '/web/privilege_group/update',
    data: data
  });
};
// 权限组信息
export var groupInfo = function groupInfo(data) {
  return axiosRequest({
    url: '/web/privilege_group/info',
    data: data
  });
};
// 权限组列表
export var groupList = function groupList(data) {
  return axiosRequest({
    url: '/web/privilege_group/list',
    data: data
  });
};
// 删除权限组
export var remove = function remove(data) {
  return axiosRequest({
    url: '/web/privilege_group/remove',
    data: data
  });
};

// 权限组员工列表
export var groupStaffList = function groupStaffList(data) {
  return axiosRequest({
    url: '/web/privilege_group/staffList',
    data: data
  });
};
// 权限组添加成员
export var addStaff = function addStaff(data) {
  return axiosRequest({
    url: '/web/privilege_group/addStaff',
    data: data
  });
};

// 权限组移除员工
export var removeStaff = function removeStaff(data) {
  return axiosRequest({
    url: '/web/privilege_group/removeStaff',
    data: data
  });
};

// 更改公司信息
export var modifybase = function modifybase(data) {
  return axiosRequest({
    url: '/web/company/update',
    data: data
  });
};

// 审批同意加入 待办同意、屏蔽、拒绝
export var inviteApproval = function inviteApproval(data) {
  return axiosRequest({
    url: '/web/invite/approval',
    data: data
  });
};

// 内容列表
export var cmsGetList = function cmsGetList() {
  return axiosRequest({
    url: '/web/cms/getList',
    methods: 'get'
  });
};

// 内容子列表和详情
export var cmsGetsubList = function cmsGetsubList(params) {
  return axiosRequest({
    url: '/web/cms/getsubList',
    methods: 'get',
    params: params
  });
};

// 内容详情
export var cmsGetContent = function cmsGetContent(params) {
  return axiosRequest({
    url: '/web/cms/getContent',
    methods: 'get',
    params: params
  });
};

// 获取可见列枚举项
export var getdepartmentvisitcolumn = function getdepartmentvisitcolumn() {
  return axiosRequest({
    url: '/web/organization/getdepartmentvisitcolumn',
    methods: 'get'
  });
};
// 获取部门可见性
export var getdepartmentvisit = function getdepartmentvisit() {
  return axiosRequest({
    url: '/web/organization/getdepartmentvisit',
    methods: 'get'
  });
};
// 设置部门可见性
export var setdepartmentvisit = function setdepartmentvisit(params) {
  return axiosRequest({
    url: '/web/organization/setdepartmentvisit',
    params: params
  });
};

// 企业认证存储
export var saveAudit = function saveAudit(params) {
  return axiosRequest({
    url: '/web/company/saveAudit',
    params: params
  });
};
// 设置全局水印
export var setglobalwatermark = function setglobalwatermark(params) {
  return axiosRequest({
    url: '/web/company/setglobalwatermark',
    params: params
  });
};

// 获取全局水印
export var getglobalwatermark = function getglobalwatermark(params) {
  return axiosRequest({
    url: '/web/company/getglobalwatermark',
    params: params
  });
};
// 获取全局水印
export var getSecuritySetting = function getSecuritySetting(params) {
  return axiosRequest({
    url: '/web/company/getSecuritySetting',
    method: 'get',
    params: params
  });
};
// 获取全局水印
export var setSecuritySetting = function setSecuritySetting(params) {
  return axiosRequest({
    url: '/web/company/setSecuritySetting',
    params: params
  });
};

// 设置自动停职/离职设置接口
export var setAutoSuspensionResign = function setAutoSuspensionResign(data) {
  return axiosRequest({
    url: '/web/company/setAutoSuspensionResign',
    data: data
  });
};

// 获取自动停职/离职设置接口
export var getAutoSuspensionResign = function getAutoSuspensionResign(data) {
  return axiosRequest({
    url: '/web/company/getAutoSuspensionResign',
    data: data
  });
};

// 获取自动停职/离职设置接口
export var agreementSave = function agreementSave(data) {
  return axiosRequest({
    url: '/web/privacy_agreement/save',
    data: data
  });
};
//
export var getAgreement = function getAgreement(data) {
  return axiosRequest({
    url: '/web/privacy_agreement/info',
    data: data
  });
};

// 权限组员工列表
export var managerList = function managerList(data) {
  return axiosRequest({
    url: '/web/privilege_manager/list',
    data: data
  });
};

// 获取管理人权限信息
export var managerInfo = function managerInfo(data) {
  return axiosRequest({
    url: '/web/privilege_manager/info',
    data: data
  });
};

// 获取管理人权限信息
export var managerCreate = function managerCreate(data) {
  return axiosRequest({
    url: '/web/privilege_manager/create',
    data: data
  });
};

// 获取管理人权限信息
export var managerEdit = function managerEdit(data) {
  return axiosRequest({
    url: '/web/privilege_manager/edit',
    data: data
  });
};

// 删除管理人权限
export var managerDelete = function managerDelete(data) {
  return axiosRequest({
    url: '/web/privilege_manager/delete',
    data: data
  });
};

// 获取管理人权限信息
export var checkSettingRelation = function checkSettingRelation(data) {
  return axiosRequest({
    url: '/web/attendance/check_setting_relation',
    data: data
  });
};